import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChildren} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormControlName, FormGroup, Validators} from '@angular/forms';
import {GenericValidator} from '../../shared/generic-validator';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import {IFlightGroup} from '../flight-group';
import {FlightGroupService} from '../flight-group.service';
import {LocationService} from '../../locations/location.service';
import {ILocation} from '../../locations/location';
import {environment} from '../../../environments/environment';
import {CustomValidators} from '../../shared/custom-validators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  templateUrl: './flight-group.component.html',
  styleUrls: ['./flight-group.component.css']
})
export class FlightGroupComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];

  pageTitle: string;
  errorMessage: string;
  flightGroupForm: FormGroup;
  flightGroup: IFlightGroup;
  locations: ILocation[];
  displayMessages: { [key: string]: string } = {};
  private _validationMessages: { [key: string]: { [key: string]: string } };
  private _genericValidator: GenericValidator;
  private _locationUrl = environment.locationUrl;
  disableForm = true;

  constructor(
    private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private _router: Router,
    private _flightGroupService: FlightGroupService,
    private _locationService: LocationService,
    public activeModal: NgbActiveModal
  ) {
    this._validationMessages = {
      flightNumber: { required: 'Flight number is required.' },
      departure: { required: 'Departure is required.' },
      destination: { required: 'Destination is required.' },
      price: {
        required: 'Price is required.',
        min: 'Price must be greater than 1.'
      },
      locationForm: { match: 'Departure and destination can\'t be same.' }
    };

    this._genericValidator = new GenericValidator(this._validationMessages);
    this._locationService.getLocations({}).subscribe(res => {
      this.locations = res.body;
      this.disableForm = false;
    }, error => (this.errorMessage = <any>error));
  }

  ngOnInit(): void {
    this.flightGroupForm = this._fb.group({
      flightNumber: ['', Validators.required],
      locationGroup: this._fb.group(
        {
          departure: ['', Validators.required],
          destination: ['', Validators.required]
        },
        { validator: CustomValidators.locationMatcher }
      ),
      price: ['', [Validators.required, Validators.min(1)]],
      flightDuration: [''],
      flightDescriptionEn: [''],
      flightDescriptionGe: [''],
    });

    if (this.flightGroupForm) {
      this.flightGroupForm.reset();
    }
    if (this.flightGroup.id === 0) {
      this.pageTitle = 'Add Flight Group';
    } else {
      this.pageTitle = `Edit Flight Group: ${this.flightGroup.flightNumber}`;
    }

    this.flightGroupForm.patchValue({
      flightNumber: this.flightGroup.flightNumber,
      locationGroup: {
        departure: this.flightGroup.departure.id,
        destination: this.flightGroup.destination.id
      },
      price: this.flightGroup.price,
      flightDuration: this.flightGroup.flightDuration,
      flightDescriptionEn: this.flightGroup.flightDescriptionEn,
      flightDescriptionGe: this.flightGroup.flightDescriptionGe
    });
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements.map(
      (formControl: ElementRef) =>
        Observable.fromEvent(formControl.nativeElement, 'blur')
    );

    Observable.merge(this.flightGroupForm.valueChanges, ...controlBlurs)
      .debounceTime(200)
      .subscribe(value => {
        this.displayMessages = this._genericValidator.processMessages(
          this.flightGroupForm
        );
      });
  }

  saveFlightGroup(): void {
    this.disableForm = true;
    if (this.flightGroupForm.dirty && this.flightGroupForm.valid) {
      const fl = {
        id: this.flightGroup.id,
        flightNumber: this.flightGroupForm.value.flightNumber,
        departure: `locations/${
          this.flightGroupForm.get('locationGroup').value.departure
        }`,
        destination: `locations/${
          this.flightGroupForm.get('locationGroup').value.destination
        }`,
        price: this.flightGroupForm.value.price,
        flightDuration: this.flightGroupForm.value.flightDuration,
        flightDescriptionEn: this.flightGroupForm.value.flightDescriptionEn,
        flightDescriptionGe: this.flightGroupForm.value.flightDescriptionGe,
      };

      this._flightGroupService.saveFlightGroup(fl).subscribe(res => {
        this.flightGroupForm.reset();
        this.activeModal.close(res);
      }, (error: any) => (this.errorMessage = <any>error));
    }
  }

  closeActiveModal() {
    if (this.flightGroupForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/flight_group/single/flight-group.component.ts